// prefer default export if available
const preferDefault = m => (m && m.default) || m

exports.components = {
  "component---src-docs-about-mdx": () => import("./../../../../src/docs/about.mdx" /* webpackChunkName: "component---src-docs-about-mdx" */),
  "component---src-docs-components-mdx": () => import("./../../../../src/docs/components.mdx" /* webpackChunkName: "component---src-docs-components-mdx" */),
  "component---src-docs-contribution-mdx": () => import("./../../../../src/docs/contribution.mdx" /* webpackChunkName: "component---src-docs-contribution-mdx" */),
  "component---src-docs-home-mdx": () => import("./../../../../src/docs/home.mdx" /* webpackChunkName: "component---src-docs-home-mdx" */),
  "component---src-pages-404-js": () => import("./../../../src/pages/404.js" /* webpackChunkName: "component---src-pages-404-js" */)
}

